exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MonthSelector__MonthSelector__1SOqb {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: start;\n        align-items: flex-start;\n    -ms-flex-align: center;\n        align-items: center;\n}\n\n.MonthSelector__Selector__2WnOP {\n    margin-bottom: 1rem;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n\n.MonthSelector__changer__1RfaD,\n.MonthSelector__MonthYear__3KyHB {\n    cursor: pointer;\n    background-color: #0087ff;\n    color: white;\n    padding: 0.5rem;\n}\n\n.MonthSelector__changer__1RfaD:hover,\n.MonthSelector__changer__1RfaD:active,\n.MonthSelector__changer__1RfaD:focus {\n    background-color: #39a2ff;\n}", ""]);

// exports
exports.locals = {
	"MonthSelector": "MonthSelector__MonthSelector__1SOqb",
	"Selector": "MonthSelector__Selector__2WnOP",
	"changer": "MonthSelector__changer__1RfaD",
	"MonthYear": "MonthSelector__MonthYear__3KyHB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/UI/MonthSelector/MonthSelector.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/UI/MonthSelector/MonthSelector.css
// module chunks = 0